<template>
  <div>
    <h6 style="margin-bottom: 10px">
      <router-link
        v-if="$route.query.dateRange && $route.query.clinicName"
        :to="{
          name: backRoute,
          query: {
            clinicId: $route.query.clinicId,
            clinicName: $route.query.clinicName,
            year: $route.query.year,
            month: $route.query.month,
            dateRange: $route.query.dateRange,
            activeView: $route.query.activeView,
          },
        }"
        ><span @click="$router.go(-1)" role="link">&#8592; Go back</span></router-link
      >
      <router-link
        v-else-if="$route.query.dateRange && !$route.query.clinicName"
        :to="{
          name: backRoute,
          params: { clinicId: $route.query.clinicId },
          query: {
            year: $route.query.year,
            month: $route.query.month,
            dateRange: $route.query.dateRange,
            activeView: $route.query.activeView,
          },
        }"
        ><span @click="$router.go(-1)" role="link">&#8592; Go back</span></router-link
      >
      <router-link
        v-else-if="!$route.query.dateRange && $route.query.backRoute"
        :to="{ name: backRoute }"
        ><span @click="$router.go(-1)" role="link">&#8592; Go back</span></router-link
      >
      <router-link
        v-else
        :to="{
          name: backRoute,
          params: { patientId: $route.params.patientId },
        }"
        ><span @click="$router.go(-1)" role="link">&#8592; Go back</span></router-link
      >
    </h6>
    <vs-card class="fontStyle">
      <h4 class="mb-3 ml-5">Overview</h4>
      <!-- view script pdf button here -->
      <div
        v-if="
          modalData.appointments.doctorTreatmentOutcome &&
          modalData.appointments.doctorTreatmentOutcome.title &&
          modalData.appointments.doctorTreatmentOutcome.title === 'Approved' &&
          treatmentPDFLink
        "
      >
        <div style="position: relative">
          <div style="position: absolute; right: 0">
            <vs-button
              @click="showScriptPdfClicked()"
              v-if="!isDocEMRTreatment"
              color="primary"
              type="border"
              >View Treatment PDF</vs-button
            >
          </div>
        </div>
      </div>
      <p class="ml-5 mb-1" style="clear: both">
        Date:
        {{
          moment(modalData.appointments.appointmentDateTime).format(
            "DD/MM/YYYY"
          )
        }}
      </p>
      <p class="ml-5 mb-1">
        Nurse:
        {{
          modalData.nurse
            ? modalData.nurse.firstName + " " + modalData.nurse.lastName
            : "N/A"
        }}
      </p>
      <p class="ml-5 mb-1">
        Doctor:
        {{
          modalData.doctor
            ? modalData.doctor.firstName + " " + modalData.doctor.lastName
            : "N/A"
        }}
      </p>
      <p class="ml-5 mb-1">
        Patient: {{ modalData.patient.firstName }}
        {{ modalData.patient.lastName }}
      </p>
      <div v-if="isScripted" style="width: 90px">
        <p
          v-if="showScripted"
          style="cursor: pointer"
          @click="
            getParentData(modalData.parentAppointmentData[0].patientCheckinId)
          "
          class="ml-5 mb-2"
        >
          <vx-tooltip text="View Parent Appointment" position="top">
            <vs-chip
              style="margin-bottom: 10px; border-radius: 15px"
              color="#33B76B"
              >Scripted</vs-chip
            >
          </vx-tooltip>
        </p>

        <p
          v-else
          style="cursor: pointer"
          @click="getChildData()"
          class="ml-5 mb-2"
        >
          <vx-tooltip text="Back To Main Appointment" position="top">
            <vs-chip
              style="margin-bottom: 10px; border-radius: 15px"
              color="#33B76B"
              >Back</vs-chip
            >
          </vx-tooltip>
        </p>
      </div>
      <vs-divider />
      <div class="ml-5">
        <router-link
          :to="{
            name: patientDetailRoute,
            params: { patientId: $route.params.patientId },
          }"
          >Patient details</router-link
        >
      </div>
    </vs-card>

    <vs-card>
      <div class="ml-5 mb-10">
        <div style="margin-top: 10px; margin-bottom: 25px">
          <h4 class="mt-2 mb-3">Treatment Plan</h4>
          <p v-if="modalData.treatments && modalData.treatments.length > 0">
            <strong style="text-decoration: underline">Treatment</strong>
            <strong style="margin-left: 5px">:</strong>
            {{ treatmentsNameArray.join(", ") }}
          </p>

          <div
            v-if="
              modalData.appointments &&
              modalData.appointments.treatmentPlans &&
              modalData.appointments.treatmentPlans.length > 0 &&
              modalData.appointments.treatmentPlans[0].product
            "
          >
            <p>
              <strong style="text-decoration: underline">Plans</strong>
            </p>
            <div
              v-for="plan in modalData.appointments.treatmentPlans"
              :key="plan._id"
              style
            >
              <p v-if="plan.product">
                {{ plan.product }}, {{ plan.area }}, {{ plan.amount }}
              </p>
            </div>
          </div>

          <div v-else>
            <p>
              <strong style="text-decoration: underline">Plans</strong>
              <strong style="margin-left: 5px">:</strong>
              N/A
            </p>
          </div>
          <vs-button
            style="padding: 10px; margin-top: 10px"
            @click="producstDrawer=!producstDrawer"
            icon-pack="feather"
            icon="icon-plus"
          >
            Add Products
          </vs-button>
          <vs-sidebar position-right  parent="body" default-index="1"  class="sidebarx" spacer v-model="producstDrawer">
            <div class="headerClass space-y-3">
              <p class="text-xl font-semibold px-4 pt-4">Add Products</p>
              <p class="px-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi qui id voluptate architecto possimus quia dolorem similique.
              </p>
              <vs-divider></vs-divider>
              <vs-input
                placeholder="Search products"
                class="w-full pb-4 px-4"
              />
            </div>
            <div v-if="products.length > 0" class="overflow-y-auto pt-4 pb-4 flex flex-col gap-2 pl-2 h-full">
              <div v-for="item in products" :key="item._id">
                <vs-checkbox
                  class="custom-checkbox"
                  v-model="selectedProducts"
                  :disabled="item.hasAftercareTemplate"
                  :vs-value="item._id"
                >
                  <span
                    :class="{ 'opacity-50 select-none': item.hasAftercareTemplate }"
                  >
                    {{ item.name }}
                  </span>
                </vs-checkbox>
              </div>
            </div>
            <div v-else class="flex flex-col justify-center items-center h-full">
              <p class="text-lg font-semibold">No products found</p>
            </div>
            <div class="p-4 flex flex-col gap-3" slot="footer">
              <vs-button @click="'handleSaveProducts'" :disabled="'isSavingProducts'">
                <vs-icon
                  v-if="'isSavingProducts'"
                  icon="refresh"
                  class="animate-spin"
                ></vs-icon>
                Save
              </vs-button>
              <vs-button type="border" @click.prevent="producstDrawer=false">
                Exit
              </vs-button>
            </div>
          </vs-sidebar>
        </div>
      </div>
    </vs-card>

    <!-- Medicare/IHI Information -->
    <vs-card v-if="hasHealthTreatmentPlans">
      <div class="ml-5 mb-10">
        <div style="margin-top: 10px; margin-bottom: 25px">
          <h4 class="mt-2 mb-3">Medicare/IHI</h4>
          <div class="space-y-4">
            <div class="flex flex-col">
              <label class="text-sm font-medium text-teal-600 mb-1">Medicare Card Number</label>
              <p class="text-gray-900">{{ displayMedicareNumber(modalData.patient.medicareNumber) || 'N/A' }}</p>
            </div>
            <div class="flex flex-col">
              <label class="text-sm font-medium text-teal-600 mb-1">Individual Reference Number (IRN):</label>
              <p class="text-gray-900">{{ modalData.patient.medicareRefNumber || 'N/A' }}</p>
            </div>
            <div class="flex flex-col">
              <label class="text-sm font-medium text-teal-600 mb-1">Valid to</label>
              <p class="text-gray-900">{{ modalData.patient.medicareExpiryDate || 'N/A' }}</p>
            </div>
            <hr class="border-gray-200 my-4" />
            <div class="flex flex-col">
              <label class="text-sm font-medium text-teal-600 mb-1">IHI Number</label>
              <p class="text-gray-900">{{ displayIHINumber(modalData.patient.ihiNumber) || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </vs-card>

    <vs-card>
      <div class="ml-5 mb-10">
        <div style="margin-top: 10px; margin-bottom: 25px">
          <h5 class="mt-2">Pre - Treatment Photos</h5>
          <vs-row>
            <vs-col
              vs-w="3"
              v-for="photo in prePhotos"
              :key="photo.photoUrl"
              class="imageClass"
            >
              <a :href="photo.photoUrl" target="_blank">
                <img :src="photo.photoUrl" width="100%" />
              </a>
            </vs-col>
          </vs-row>
          <vs-button
            style="padding: 10px; margin-top: 10px"
            @click="showPrePhotoHistory"
            icon-pack="feather"
            icon="icon-eye"
            >View Pre Treatment Image Trial</vs-button
          >
          <p v-if="prePhotos.length === 0">N/A</p>
        </div>

        <div style="margin-top: 10px; margin-bottom: 25px">
          <h5 class="mt-2">Post - Treatment Photos</h5>
          <vs-row>
            <vs-col
              vs-w="3"
              v-for="photo in postPhotos"
              :key="photo.photoUrl"
              class="imageClass"
            >
              <a :href="photo.photoUrl" target="_blank">
                <img :src="photo.photoUrl" width="100%" />
              </a>
            </vs-col>
          </vs-row>
          <vs-button
            style="padding: 10px; margin-top: 10px"
            @click="showPostPhotoHistory"
            icon-pack="feather"
            icon="icon-eye"
            >View Post Treatment Image Trial</vs-button
          >
          <p v-if="postPhotos.length === 0">N/A</p>
        </div>

        <div style="margin-top: 10px; margin-bottom: 25px">
          <h5 class="mt-2">Procedure Notes</h5>
          <vs-row
            v-if="
              modalData.groupedProcedureNote &&
              modalData.groupedProcedureNote[0].partId
            "
          >
            <vs-col
              style="width: 350px; height: 600px"
              vs-w="3"
              v-for="photo in modalData.groupedProcedureNote"
              :key="photo.partImage"
              class="imageClass outer"
            >
              <img
                :src="photo.partImage"
                style="width: 100%; height: 100%"
                width="100%"
              />
              <div class="overlay" @click="overlayClicked(photo)">
                <p class="text">{{ photo.notes.length }} Notes</p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row v-else>
            <p>N/A</p>
          </vs-row>
          <vs-button @click="noteDetail = true">Add Procedure Notes</vs-button>
        </div>
      </div>
    </vs-card>

    <vs-popup
      class="holamundo"
      :title="popupData.partName"
      :active.sync="popupActive"
    >
      <vs-row>
        <vs-col
          style="max-height: 500px"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
        >
          <img :src="popupData.partImage" style="width: 100%; height: 100%" />
        </vs-col>
        <vs-col vs-type="flex" vs-align="left" vs-w="8">
          <ul class="noteUl">
            <li v-for="(note, index) in popupData.partNotes" :key="index">
              {{ note.note }}
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-card>
      <div class="ml-5" v-if="modalData.appointments.doctorTreatmentOutcome">
        <h4 class="mb-3">Doctor Notes</h4>
        <p>Status: {{ modalData.appointments.doctorTreatmentOutcome.title }}</p>
        <p>Note: {{ modalData.appointments.doctorTreatmentOutcome.note }}</p>
        <vs-button
          style="padding: 10px; margin-top: 10px"
          @click="showDoctorNoteHistory"
          icon-pack="feather"
          icon="icon-eye"
          >View Audit Trail</vs-button
        >
      </div>
      <div class="ml-5" v-else>
        <h4 class="mb-3">Doctor Notes</h4>
        <p>N/A</p>
      </div>
    </vs-card>

    <vs-popup
      class="holamundo"
      title="Doctor Note History"
      :active.sync="treatmentOutcomeHistoryPopup"
    >
      <div class="p-5">
        <h3 class="mb-3">Doctor Note History</h3>
        <vs-row v-if="treatmentOutcomeHistory.length > 0" class="max-h-sm overflow-y-auto pr-3">
          <vs-col vs-type="flex" vs-align="left" vs-w="12">
            <ul class="w-full flex flex-col gap-3">
              <li :key="index" v-for="(datum, index) of treatmentOutcomeHistory">
                <vs-card class="m-0">
                  <div class="flex items-center justify-between mb-3">
                    <p class="font-semibold text-black">
                      {{ moment(datum.createdAt).format("DD/MM/YYYY") }}
                    </p>
                    <p>Status: {{ datum.title }}</p>
                  </div>
                  <p class="font-normal">Note: {{ datum.note }}</p>
                </vs-card>
              </li>
            </ul>
          </vs-col>
        </vs-row>
        <vs-row v-else>
          <p>No history record found</p>
        </vs-row>
      </div>
    </vs-popup>

    <vs-card>
      <div class="ml-5">
        <h4 class="mb-3">Consent Form</h4>
        <p>
          Signed At:
          {{ modalData.consentFormSignedAt ? moment(modalData.consentFormSignedAt).format("DD/MM/YYYY") : "N/A" }}
        </p>
        <vs-button
          style="padding: 10px; margin-top: 10px"
          @click="showConsentForm"
          icon-pack="feather"
          icon="icon-eye"
          >View Consent Form</vs-button
        >
      </div>
    </vs-card>

    <vs-popup
      class="holamundo"
      title="Consent Form"
      :active.sync="consentPopup"
    >
      <div class="p-5">
        <div
          v-if="
            modalData.treatmentConsentAgreed &&
            modalData.treatmentConsentAgreed.length > 0
          "
        >
          <div>
            <h4 class="font-medium mb-3">Consent Agreed</h4>
            <ul style="list-style-type: disc; padding-left: 35px">
              <li
                :key="index"
                v-for="(datum, index) of modalData.treatmentConsentAgreed"
                class="mb-2"
              >
                {{ datum.question || "N/A" }}
                <ul v-if="datum.populateTreatmentPlans">
                  <li
                    class="text-sm"
                    style="margin-left: 20px"
                    v-for="(treatment, ii) of modalData.appointments.treatmentPlans"
                    :key="ii">
                    {{ treatment.product }}, {{ treatment.amount }}{{ treatment.unit }}, {{ treatment.area }}
                  </li>
                </ul>
                <ul v-if="!datum.populateTreatmentPlans && (datum.answer && datum.answer.length)">
                  <li
                    class="text-sm"
                    style="margin-left: 20px">
                    {{ formatAgreedAnswer(datum.answer) }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div vs-type="flex" vs-align="left" vs-w="12">
            <div style="margin-top: 20px">
              <h4 class="font-medium mb-2">Signature</h4>
              <div style="padding-left: 35px; width: 250px; height: auto">
                <img
                  :src="modalData.eSignature"
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p>No consent data found</p>
        </div>
      </div>
    </vs-popup>

    <!--pop up for post photo history-->
    <vs-popup
      class="holamundo"
      title="Post Treatment Photo History"
      :active.sync="postPhotosHistoryPopup"
    >
      <div class="p-5">
        <vs-row class="flex justify-end mb-3">
          <div>
            <label class="image-upload profile-image-upload p-1 rounded-lg border inline-block border-solid border-primary">
              <div class="flex items-center justify-center">
                <vs-icon icon-pack="feather" icon="icon-upload" class="mr-1" />
                <div>
                  Upload Post - Treatment Photo
                </div>
              </div>
              <input
                type="file"
                accept="image/*"
                @change="uploadImage($event, false, 'profile-image-upload')"
                id="file-input"
                hidden
              />
            </label>
          </div>
        </vs-row>
        <vs-row v-if="postPhotosHistory.length > 0" class="max-h-sm overflow-y-auto">
          <vs-col vs-type="flex" vs-align="left" vs-w="12">
            <ul class="w-full flex flex-wrap gap-3">
              <li :key="index" v-for="(datum, index) of postPhotosHistory" class="w-48 h-48 rounded-lg overflow-hidden">
                <div class="m-0 h-full flex w-full">
                  <div
                    vs-w="3"
                    v-for="photo in datum.photos"
                    :key="photo.photoUrl"
                    class="w-full relative"
                  >
                    <div class="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-green-light">
                      <p class="p-2 text-sm">
                        {{ moment(datum.photos[0].createdAt).format("DD/MM/YYYY") }}
                      </p>
                      <vs-button
                        color="danger"
                        @click="deleteImage(photo)"
                        icon-pack="feather"
                        icon="icon-trash-2"
                        type="flat"
                      />
                    </div>
                    <a :href="photo.photoUrl" target="_blank">
                      <img
                        :src="photo.photoUrl"
                        class="h-full w-full object-cover"
                      />
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </vs-col>
        </vs-row>
        <vs-row v-else>
          <p>No history record found</p>
        </vs-row>
      </div>
    </vs-popup>

    <!--pop up for pre photo history-->
    <vs-popup
      class="holamundo"
      title="Pre Treatment Photo History"
      :active.sync="prePhotosHistoryPopup"
    >
      <div class="p-5">
        <vs-row class="flex justify-end mb-3">
          <div>
            <label class="image-upload profile-image-upload p-1 rounded-lg border inline-block border-solid border-primary">
              <div class="flex items-center justify-center">
                <vs-icon icon-pack="feather" icon="icon-upload" class="mr-1" />
                <div>
                  Upload Pre - Treatment Photo
                </div>
              </div>
              <input
                type="file"
                accept="image/*"
                @change="uploadImage($event, true, 'profile-image-upload')"
                id="file-input"
                hidden
              />
            </label>
          </div>
        </vs-row>
        <vs-row v-if="prePhotosHistory.length > 0" class="max-h-sm overflow-y-auto">
          <vs-col vs-type="flex" vs-align="left" vs-w="12">
            <ul class="w-full flex flex-wrap gap-3">
              <li :key="index" v-for="(datum, index) of prePhotosHistory" class="w-48 h-48 rounded-lg overflow-hidden">
                <div class="m-0 h-full flex w-full">
                  <div
                    vs-w="3"
                    v-for="photo in datum.photos"
                    :key="photo.photoUrl"
                    class="w-full relative"
                  >
                    <div class="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-green-light">
                      <p class="p-2 text-sm">
                        {{ moment(datum.photos[0].createdAt).format("DD/MM/YYYY") }}
                      </p>
                      <vs-button
                        color="danger"
                        @click="deleteImage(photo)"
                        icon-pack="feather"
                        icon="icon-trash-2"
                        type="flat"
                      />
                    </div>
                    <a :href="photo.photoUrl" target="_blank">
                      <img
                        :src="photo.photoUrl"
                        class="h-full w-full object-cover"
                      />
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </vs-col>
        </vs-row>
        <vs-row v-else>
          <p>No history record found</p>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup title="Add Procedure Notes" :active.sync="noteDetail">
      <form autocomplete="off">
        <div class="flex flex-no-wrap m-5">
          <div class="mr-2 w-1/2">
            <vs-select
              id="gender"
              autocomplete
              :success="
                !errors.first('basic.bodyPartId') && newNote.bodyPartId != ''
              "
              val-icon-success="done"
              val-icon-danger="error"
              :danger="errors.first('basic.bodyPartId') ? true : false"
              v-validate="'required'"
              name="bodyPartId"
              data-vv-as="bodyPartId"
              label="Gender"
              class="w-full"
              data-vv-scope="basic"
              :danger-text="errors.first('basic.bodyPartId')"
              v-model="newNote.bodyPartId"
            >
              <vs-select-item
                :key="index"
                :value="item._id"
                :text="item.gender"
                v-for="(item, index) in bodyParts"
              />
            </vs-select>
          </div>
          <div class="ml-2 w-1/2">
            <vs-select
              id="parts"
              autocomplete
              :success="!errors.first('basic.partId') && newNote.partId != ''"
              val-icon-success="done"
              val-icon-danger="error"
              :danger="errors.first('basic.partId') ? true : false"
              v-validate="'required'"
              name="partId"
              data-vv-as="partId"
              label="Body part"
              class="w-full"
              data-vv-scope="basic"
              :danger-text="errors.first('basic.partId')"
              v-model="newNote.partId"
            >
              <vs-select-item
                :key="index"
                :value="part._id"
                :text="part.name"
                v-for="(part, index) in parts"
              />
            </vs-select>
          </div>
        </div>
        <div class="w-full">
          <div class="m-5">
            <vs-input
              :success="!errors.first('basic.title') && newNote.title != ''"
              val-icon-success="done"
              val-icon-danger="error"
              :danger="errors.first('basic.title') ? true : false"
              v-validate="'required|max:150'"
              name="title"
              data-vv-as="title"
              label="Title"
              class="w-full"
              data-vv-scope="basic"
              :danger-text="errors.first('basic.title')"
              v-model="newNote.title"
            />
          </div>

          <div class="m-5">
            <vs-textarea
              :success="!errors.first('basic.note') && newNote.note != ''"
              val-icon-success="done"
              val-icon-danger="error"
              :danger="errors.first('basic.note') ? true : false"
              v-validate="'required|max:1000'"
              name="note"
              data-vv-as="note"
              label="Note"
              class="w-full"
              data-vv-scope="basic"
              :danger-text="errors.first('basic.note')"
              v-model="newNote.note"
            />
          </div>
          <div class="m-5">
            <vs-button
              size="normal"
              @click="saveData"
              icon-pack="feather"
              class="mr-2"
              >Save Procedure Notes</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import { formatIHINumber, formatMedicareNumber } from '@/utils/healthTreatment';

export default {
  components: {
  },
  props: {
    backRoute: {
      type: String,
    },
    patientDetailRoute: {
      type: String,
    },
  },
  data() {
    return {
      newNote: {
        title: '',
        note: '',
        partId: '',
        bodyPartId: '',
      },
      bodyParts: [],
      parts: [],
      modalData: {
        createdAt: '',
        nurse: {},
        doctor: {},
        patient: {},
        appointments: {},
      },
      noteDetail: false,
      treatmentsNameArray: [],
      showScripted: true,
      isScripted: false,
      prePhotos: [],
      postPhotos: [],
      popupActive: false,
      popupData: {
        partName: '',
        partImage: '',
        partNotes: '',
      },
      consentPopup: false,
      treatmentOutcomeHistoryPopup: false,
      treatmentOutcomeHistory: [],
      postPhotosHistoryPopup: false,
      prePhotosHistoryPopup: false,
      postPhotosHistory: [],
      prePhotosHistory: [],
      producstDrawer: false,
      products: [],
      treatmentPDFLink: '',
    };
  },
  watch: {
    'newNote.bodyPartId'(val) {
      this.parts = _.filter(this.bodyParts, ['_id', val])[0].parts;
    },
  },
  computed: {
    isDocEMRTreatment() {
      return `${this.modalData.nurse._id}` === `${this.modalData.doctor._id}`;
    },
    hasHealthTreatmentPlans() {
      return this.modalData.appointments && this.modalData.appointments.treatmentPlans && this.modalData.appointments.treatmentPlans.some(treatment => 
        treatment.isHealthTreatment === true
      );
    },
  },
  methods: {
    ...mapActions('nurse', [
      'getTreatmentDetails',
      'updateNotes',
      'getBodyParts',
      'uploadAppointmentPhoto',
      'deleteAppointmentPhoto',
    ]),
    ...mapActions('general', ['showScriptPdf']),
    ...mapActions('doctor', [
      'fetchTreatmentOutcomesList',
      'fetchPostPhotoHistoryList',
    ]),
    formatAgreedAnswer(answers) {
      return answers.join(', ');
    },
    displayIHINumber(ihiNumber) {
      return formatIHINumber(ihiNumber);
    },
    displayMedicareNumber(medicareNumber) {
      return formatMedicareNumber(medicareNumber);
    },
    async saveData() {
      try {
        let isValid = await this.$validator.validateAll('basic');
        if (isValid) {
          await this.updateNotes({
            appointmentId: this.modalData.appointments._id,
            update: this.newNote,
          });
          this.treatmentDetails();
          this.newNote = {
            title: '',
            note: '',
            partId: '',
            bodyPartId: '',
          };
          this.$validator.reset();
          this.noteDetail = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async uploadImage(event, isBeforePhoto) {
      try {
        this.$vs.loading();
        await this.uploadAppointmentPhoto({
          event: event,
          isBeforePhoto: isBeforePhoto,
          appointmentId: this.modalData.appointments._id,
        });
        this.postPhotosHistoryPopup = false;
        this.prePhotosHistoryPopup = false;
        this.mount();
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        if (error && error.response.status === 415) {
          this.$vs.notify({
            title: 'Upload Failed',
            text: 'File Format Not Supported',
            color: 'danger',
          });
        } else {
          this.$vs.notify({
            title: 'Upload Failed',
            text: 'Please try again later.',
            color: 'danger',
          });
        }
      }
    },
    async deleteImage({ photoUrl, _id , isBeforePhoto}) {
      try {
        this.$vs.loading();
        const photoId = isBeforePhoto?_.filter(this.prePhotos, ['photoUrl', photoUrl])[0]._id:_.filter(this.postPhotos, ['photoUrl', photoUrl])[0]._id;
        await this.deleteAppointmentPhoto({
          appointmentHistoryId: _id,
          photoId: photoId,
          appointmentId: this.modalData.appointments._id,
          imageUrl: photoUrl,
        });
        this.postPhotosHistoryPopup = false;
        this.prePhotosHistoryPopup = false;
        this.mount();
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    async treatmentDetails(checkInId = null) {
      let patientCheckinId = this.$route.params.checkinId;

      if (checkInId) {
        patientCheckinId = checkInId;
      }

      await this.getTreatmentDetails(patientCheckinId).then((res) => {
        this.modalData = res.data.data;
        if (this.modalData.treatments && this.modalData.treatments.length > 0)
          this.treatmentsNameArray = Object.keys(this.modalData.treatments).map(
            (index) => {
              return this.modalData.treatments[index].treatmentName;
            }
          );
      });
    },
    async getParentData(parentAppointmentCheckInId) {
      this.$vs.loading();
      await this.treatmentDetails(parentAppointmentCheckInId);
      this.postPhotos = [];
      this.prePhotos = [];
      if (this.modalData.appointments.photos) {
        this.modalData.appointments.photos.forEach((photo) => {
          if (photo.isBeforePhoto == false) {
            this.postPhotos.push(photo);
          } else this.prePhotos.push(photo);
        });
      }
      this.showScripted = false;
      this.$vs.loading.close();
    },
    async getChildData() {
      this.$vs.loading();
      await this.treatmentDetails();
      this.postPhotos = [];
      this.prePhotos = [];
      if (this.modalData.appointments.photos) {
        this.modalData.appointments.photos.forEach((photo) => {
          if (photo.isBeforePhoto == false) {
            this.postPhotos.push(photo);
          } else this.prePhotos.push(photo);
        });
      }
      this.showScripted = true;
      this.$vs.loading.close();
    },
    moment(date) {
      return moment(date);
    },
    createNurseHandler() {
      this.$router.push({ name: 'FranchiseNurseCreate' });
    },
    overlayClicked(params) {
      this.popupActive = true;
      this.popupData = {
        partImage: params.partImage,
        partName: params.partName,
        partNotes: params.notes,
      };
    },
    showConsentForm() {
      this.consentPopup = true;
    },
    showScriptPdfClicked() {
      const link = document.createElement('a');
      link.href = this.treatmentPDFLink;
      link.setAttribute('target', '_blank');
      link.click();  
    },
    showDoctorNoteHistory() {
      this.treatmentOutcomeHistoryPopup = true;
    },
    getDoctorNoteHistory(appointmentId) {
      this.fetchTreatmentOutcomesList(appointmentId).then((res) => {
        this.treatmentOutcomeHistory = res.data.data;
      });
    },
    showPrePhotoHistory() {
      this.prePhotosHistoryPopup = true;
    },
    showPostPhotoHistory() {
      this.postPhotosHistoryPopup = true;
    },
    async getParts() {
      const res = await this.getBodyParts();
      this.bodyParts = res.data.data;
    },
    getPostPhotoHistory(appointmentId) {
      const data = {
        id: appointmentId,
        isBeforePhoto: false,
      };
      this.fetchPostPhotoHistoryList(data).then((res) => {
        this.postPhotosHistory = res.data.data;
      });
    },
    getPrePhotoHistory(appointmentId) {
      const data = {
        id: appointmentId,
        isBeforePhoto: true,
      };
      this.fetchPostPhotoHistoryList(data).then((res) => {
        this.prePhotosHistory = res.data.data;
      });
    },
    async mount() {
      await this.getParts();
      await this.treatmentDetails();
      this.postPhotos = [];
      this.prePhotos = [];
      if(this.modalData.appointments._id){
          try {
          const scriptPDF = await this.showScriptPdf({ appointmentId: this.modalData.appointments._id });
          this.treatmentPDFLink = scriptPDF.data.data.pdfLink;
        } catch (error) {
          console.log('No PDF found');
        }
      }
      if (this.modalData.appointments.photos) {
        this.modalData.appointments.photos.forEach((photo) => {
          if (photo.isBeforePhoto == false) {
            this.postPhotos.push(photo);
          } else this.prePhotos.push(photo);
        });
      }

      if (this.modalData.appointments.isScripted) {
        this.isScripted = true;
      }

      if (this.modalData.appointments.doctorTreatmentOutcome) {
        await this.getDoctorNoteHistory(this.modalData.appointments._id);
      }

      if (this.modalData.appointments.photos) {
        await this.getPostPhotoHistory(this.modalData.appointments._id);
        await this.getPrePhotoHistory(this.modalData.appointments._id);
      }
    },
  },
  async mounted() {
    this.mount();
  },
};
</script>
<style>
.imageClass {
  padding: 5px;
  margin: 5px;
}
.imageClass img {
  padding: 5px;
}

p {
  font-size: 15px;
  font-weight: 500;
}

.outer {
  position: relative;
}

.overlay {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.5;
  top: 0;
  left: 0;
  cursor: pointer;
}
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  cursor: pointer;
}

ul.noteUl {
  padding-left: 50px;
  list-style: disc;
  text-align: justify;
}

ul.noteUl li {
  margin: 10px 0;
}

.vs-sidebar--background {
  z-index: 52000 !important;
}

.vs-sidebar.vs-sidebar-position-right {
  z-index: 53000;
}

.sidebarx .vs-sidebar-primary {
  max-width: none;
}

@media (min-width: 768px) {
  .sidebarx .vs-sidebar-primary {
    max-width: 350px;
  }
}
</style>
